import { render, staticRenderFns } from "./asigGeoLeechero.vue?vue&type=template&id=45c2eb9c&"
import script from "./asigGeoLeechero.vue?vue&type=script&lang=js&"
export * from "./asigGeoLeechero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports